import { Expose } from "class-transformer";

export class UnassignPlanningBoardWorkshopVehicleDto {
  @Expose()
  vehicleId: string;
}
